module.exports = __webpack_public_path__ + "static/15-0887601903f763ca1af5c90d85cfd23c.jpg";